import { LinearProgress, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { capitalCase } from 'change-case';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { TableMoreMenu } from 'src/components/table';
import { fPercent } from 'src/utils/formatNumber';
import { getAge } from 'src/utils/formatTime';
import CustomLink from 'src/careflow/common/CustomLink';
import { WorkflowService } from 'src/careflow/ph-core/workflow/api/WorkflowService';

export default function Row({ row, menuItems, width }: any) {
  const [stages, setStages] = useState<any>([]);
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (row?.scope) fetchWorkFlow(row?.scope);
  }, [row]);

  const fetchWorkFlow = async (workflowType: string | undefined) => {
    const getWorkflow = await WorkflowService.getWorkflowByCode(workflowType);
    setStages(getWorkflow?.stages);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow>
      <TableCell>
        <Typography noWrap variant="body2">
          <CustomLink to={row?.path}>{row?.internalNumber}</CustomLink>
        </Typography>
      </TableCell>
      <TableCell>
        <Typography>
          {row?.createdOnFormatted &&
            format(new Date(row?.createdOnFormatted), 'MMM dd, yyyy hh:mm')}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography>{row?.birthDate && `${getAge(new Date(row?.birthDate))} years`}</Typography>
      </TableCell>
      <TableCell>
        <Typography sx={{ textTransform: 'capitalize' }}>{row?.statusIndexed}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{row?.status && capitalCase(row.status.replace('.', ' '))}</Typography>
      </TableCell>
      <TableCell>
        <Typography textTransform="capitalize">
          {row?.owner && row.owner.split('@')[0].replace('.', ' ')}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography>{row?.scope}</Typography>
      </TableCell>
      <TableCell>
        <ProgressBar row={row?.stepOrder} stepLength={stages?.length} />
      </TableCell>
      {menuItems && (
        <TableCell align="right">
          <TableMoreMenu
            width={width}
            open={openMenu}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            actions={menuItems}
          />
        </TableCell>
      )}
    </TableRow>
  );
}

function ProgressBar({ row, stepLength }: any) {
  const percent = (row / stepLength) * 100;

  return (
    <Stack spacing={1}>
      {stepLength !== undefined && percent !== Infinity && (
        <>
          <LinearProgress variant="determinate" value={percent} color="info" sx={{ mt: 1 }} />
          <Stack
            direction="row"
            justifyContent={
              (percent >= 50 && percent < 100 && 'center') || (percent === 100 && 'right') || 'left'
            }
          >
            <Typography variant="subtitle2">{fPercent(percent) + ` - `}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {row + `/${stepLength}`}
            </Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
}
